import * as React from 'react';

const ShowTimeContext = React.createContext<boolean>(false);

export const ShowTimeProvider = ShowTimeContext.Provider;
export const useShowTime = () => React.useContext(ShowTimeContext);

export default ShowTimeContext;
